import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

interface StationNumberInputProps {
  value?: number;
  onChange?: (value: number) => void;
  id?: string;
  name?: string;
}

const StationNumberInput = ({ value, onChange, id = 'stationNumber', name = 'stationNumber' }: StationNumberInputProps) => {
  const [displayValue, setDisplayValue] = useState<string>(value?.toString() ?? '');

  // Sync display value when prop value changes from outside
  useEffect(() => {
    setDisplayValue(value?.toString() ?? '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    if (inputValue === '') {
      setDisplayValue('');
      onChange?.(0);
      return;
    }
    
    // Extract only digits and get the last digit
    const digits = inputValue.replace(/\D/g, ''); // Remove non-digits
    if (digits.length > 0) {
      const lastDigit = digits[digits.length - 1];
      const digitNumber = parseInt(lastDigit, 10);
      setDisplayValue(lastDigit);
      onChange?.(digitNumber);
    }
  };

  return (
    <Container>
      <input 
        type='number' 
        id={id} 
        name={name} 
        value={displayValue} 
        onChange={handleChange}
        min={0}
        max={9}
      />
    </Container>
  );
};

export default StationNumberInput;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  input {
    width: 100%;
    height: 45px;
    border-radius: 4px;
    border: 1px solid #dadada;
    background: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0 12px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;
